<template>
    <div>
        <breadcrumb :routerList="[{to:'/dingd/myOrderList',title:'订单管理'},{title:'创建订单'}]"/>


        <!---------------------------------------------------项目信息-------------------------------------------------------------------->
        <div class="h-piece">
            <div class="h-pieceIn2 n-xiao" v-if="showXiangmu">
                <div class="h-pieceTitle2 " style="margin-left:10px">
                    <h1>项目信息</h1>
                </div>
                <div class="h-pieceCon2">
                    <div class="h-formLine">
                        <el-form :model="q" label-position="right" :inline="true"
                                 class="demo-ruleForm h-formbLine">
                            <el-form-item label="项目名称" class="h-elformWrap-2">
                                <el-select v-model="q.projectName" @change="queryXiangmu()"
                                           placeholder="请选择" disabled>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="项目合同编号" class="h-elformWrap-2">
                                <el-input v-model="q.orderSubContract" placeholder="请先选择项目"></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
            <!-------------------------------------------------------项目信息-------------------------------------------------------------------->


            <!-------------------------------------------------------订单信息-------------------------------------------------------------------->

            <div class="h-pieceIn2">
                <div class="h-pieceTitle2" style="margin-left:10px">
                    <h1>订单信息</h1>
                </div>
                <div class="h-pieceCon2">
                    <div class="h-formLine n-two">
                        <el-form :model="q" label-position="right" :inline="true"
                                 class="demo-ruleForm h-formbLine">
                            <el-form-item label="销售区域" class="h-elformWrap-2">
                                <el-input v-model="xsqyStr" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="销售组织" class="h-elformWrap-2">
                                <el-input v-model="xszzStr" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="分销渠道" class="h-elformWrap-2">
                                <el-input v-model="fxqdStr" readonly></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
            <!-------------------------------------------------------订单信息-------------------------------------------------------------------->


            <!-------------------------------------------------------客户信息-------------------------------------------------------------------->
            <div class="h-pieceIn2">
                <div class="h-pieceTitle2" style="margin-left:10px">
                    <h1>客户信息</h1>
                </div>
                <div class="h-pieceCon2">
                    <div class="h-formLine n-two">
                        <el-form :model="c" label-position="right" :inline="true"
                                 class="demo-ruleForm h-formbLine" :rules="rules1">
                            <el-form-item prop="contactName" label="售达方名称" class="h-elformWrap-2">
                                <el-input v-model="c.soldToName" placeholder="请输入" readonly>
                                    <i
                                            class="el-icon-search el-input__icon"
                                            slot="suffix"
                                            @click="openShoudf"
                                            v-if="checkUserType">
                                    </i>
                                </el-input>
                            </el-form-item>
                            <el-form-item prop="contactName" label="售达方区域" class="h-elformWrap-2">
                                <el-input v-model="c.soldToAreaCode" placeholder="自带出" readonly></el-input>
                            </el-form-item>

                            <el-form-item prop="customerChannelCode" label="客户渠道" class="h-elformWrap-2">
                                <brselect clearable category="sales_region" :v="c.customerChannelCode"
                                          v-model="c.customerChannelCode"></brselect>
                            </el-form-item>

                            <el-form-item prop="isStockUp" label="是否备货" class="h-elformWrap-2" v-if="showIsStockUp">
                                <brselect clearable category="shifou_keyong" :v="c.isStockUp"
                                          v-model="c.isStockUp"></brselect>
                            </el-form-item>

                            <el-form-item prop="contactName" label="收货联系人" class="h-elformWrap-2">
                                <el-input v-model="c.contactName" placeholder="请输入"></el-input>
                            </el-form-item>

                            <el-form-item
                                    label="预计收货日期"
                                    class="h-elformWrap-2"
                                    width="120px"
                                    prop="receivedTime">
                                <div class="block">
                                    <el-date-picker
                                            v-model="c.receivedTime"
                                            type="date"
                                            value-format="yyyy-MM-dd"
                                            placeholder="--选择--"
                                            :picker-options="pickerOptions">
                                    </el-date-picker>
                                </div>
                            </el-form-item>

                            <el-form-item label="联系电话" width="300" class="h-elformWrap-2" style="float: left"
                                    prop="firsttelephone">
                                <div class="block">
                                    <el-input v-model.number="c.firsttelephone" placeholder="请输入"></el-input>
                                </div>
                            </el-form-item>
                            <el-form-item label="选择收货地址" class="h-elformWrap-2" style=" margin-left:-50px;">
                                <el-input clearable v-model="c.toAddress" style="width: 500px;" readonly>
                                    <i
                                        class="el-icon-search el-input__icon"
                                        slot="suffix"
                                        @click="handleIconClick">
                                    </i>
                                </el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
        <!-------------------------------------------------------客户信息-------------------------------------------------------------------->


        <!-------------------------------------------------------产品信息-------------------------------------------------------------------->
        <div class="h-table h-mrt30    bbbb" v-if="clickActive==1">
            <div class="h-pieceTitle2 message">
                <h1 class="h1">产品信息</h1>
            </div>
            <el-table
                    ref="multipleTable"
                    @selection-change="handleSelectionChange"
                    :data="tableData2"
                    stripe
					border
                    style="width: 100%">
                <el-table-column
                        fixed
                        type="index"
                        label="#"
                        width="40">
                </el-table-column>

                <el-table-column
                        prop="materialCode"
                        label="产品编码"
                        width="160">
                    <!--                    <template slot-scope="scope" v-show="showHidden">-->
                    <!--                        <el-input v-model="scope.row.materialCode" @change="getSingleOrder(scope.row)" placeholder="请输入"-->
                    <!--                                  class="DshuR" :disabled="showHidden2">-->
                    <!--                            <i-->
                    <!--                                    class="el-icon-edit el-input__icon"-->
                    <!--                                    slot="suffix"-->
                    <!--                                    @click="showProcuct">-->
                    <!--                            </i>-->
                    <!--                        </el-input>-->
                    <!--                    </template>-->
                </el-table-column>
                <el-table-column
                        prop="proModelCode"
                        label="产品型号"
						:show-overflow-tooltip="true"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="proNumber"
                        label="订单数量"
                        width="150"
                        :rules="[
								  { required: true, message: '请输入排序名称'},
								  { type: 'number', message: '必须为数字值',trigger: 'change'}
								]">
                    <template slot-scope="scope">
                        <el-input v-model.number="scope.row.proNumber" @change="getTotalPrice(scope.row)"
                                  placeholder="请输入"
                                  class="DshuR" auto-complete="off"></el-input>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="proBenchmarkPrice"
                        label="基准价"
                        width="150">
                </el-table-column>
                <el-table-column
                        prop="specialPrice"
                        label="特价"
                        width="150">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.specialPrice"
                                   placeholder="请选择" clearable @change="choseTJ(scope.row)" @clear="clearEV(scope.row)">
                            <el-option v-for="item in tjList"
                                       :key="item.tjdtid"
                                       :label="item.tejia"
                                       :value="item.tejia">
                            </el-option>
                        </el-select>
                    </template>
                </el-table-column>

                <el-table-column
                        prop="specialPriceNum"
                        label="特价余量"
                        width="150">
                </el-table-column>

                <el-table-column
                        prop="spare3"
                        label="定制需求"
                        width="150"
                        v-if="showIsCustomed">
                    <template scope="scope">
                        <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                            <el-form-item label="">
                                <el-select v-model="scope.row.spare3" style="width:1.5rem;"
                                           :disabled="scope.row.cflag">
                                    <el-option label="外壳镀金" value="1"></el-option>
                                    <el-option label="功率提升" value="2"></el-option>
                                    <el-option label="不定制" value="0"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-form>
                    </template>
                </el-table-column>

                <el-table-column
                        prop="extraPrice"
                        label="定制加价"
                        width="150"
                        v-if="showIsCustomed">
                    <template slot-scope="scope">
                        <el-input v-model.number="scope.row.extraPrice" @change=""
                                  placeholder="请输入"
                                  class="DshuR" auto-complete="off"></el-input>
                    </template>
                </el-table-column>

                <el-table-column
                        prop="finalPrice"
                        label="成交价"
                        width="150">
                </el-table-column>

                <el-table-column
                        prop="totalPrice"
                        label="总价"
                >
                </el-table-column>

                <el-table-column label="操作" width="100" fixed="right">
                    <template slot-scope="scope">
                        <el-button
                                type="text"
                                size="small"
                                class="h-tableLink h-btn"
                                v-model="scope.row.id"
                                @click="deleteThis(scope.row.id)">
                            删除
                        </el-button>
						<!-- <div class="l-operationBox">
							<span class="l-operationlist br-operation-delete" title="删除" @click="deleteThis(scope.row.id)"></span>
						</div> -->
                    </template>
                </el-table-column>
            </el-table>
            <div style="background-color: rgb(94, 182, 233);" v-if="showHidden" @click="showProcuct">
                <img src="../../assets/images/pimg/jiahao.png" alt="">
            </div>
            <div class="jieguo" v-if="!showIsFree">
                <span class="bizhong">币种</span>
                <span class="renminbi">{{ currency }}</span>
                <span class="dingdan">订单总价</span>
                <span class="yuan">{{ allTotalPrice }}</span>
                <span class="xianjin">现金余额</span>
                <span class="money">{{ cashBalance }}</span>
                <span class="xianjin">现金占用</span>
                <span class="money">{{ cashOccupy }}</span>
                <span class="xianjin">信贷选择</span>
                <el-select v-model="n.id"
                        placeholder="请选择" @change="creditChange(n)">
                    <el-option v-for="item in creditData"
                        :key="item.id"
                        :label="item.creditMsg"
                        :value="item.id">
                    </el-option>
                </el-select>
                <span class="xianjin">信贷账期</span>
                <span class="money">{{ n.paymentdate }}</span>
                <span class="xianjin">信贷占用</span>
                <span class="zhangqi">{{ creditOccupy }}</span>
                <span class="jiazhi">净价值</span>
                <span class="make">{{ n.netPrice }}</span>
            </div>
            <div class="jieguo" v-if="showIsFree">
                <span class="bizhong">币种</span>
                <span class="renminbi">{{ currency }}</span>
                <span class="dingdan">订单总价</span>
                <span class="yuan">{{ allTotalPrice }}</span>
                <span class="xianjin">免费订单余额</span>
                <span class="money">{{ freeTotal }}</span>
            </div>
        </div>
        <!-------------------------------------------------------产品信息-------------------------------------------------------------------->
        <div class="anniu">
            <el-row>
                <el-button class="h-btn h-bBtn h-bgwhite" style="margin-right:10px;" @click="jump">返回</el-button>
                <el-button class="h-btn h-bBtn h-bggreen" @click="createNewOrder(10)">暂存</el-button>
                <el-button class="h-btn h-bBtn h-bgblue2" @click="createNewOrder(20)">确认提交</el-button>
            </el-row>
        </div>
        <!--------------------------------------------------------------------收货地址弹出框-------------------------------------------------------->
        <!--物料-->
        <wxwl :visible.sync="showwuliaodialog" v-if="showwuliaodialog" @choseObj="choseWuliao" :usercode="currentUser"
              title="选择物料"/>
        <!--售达方-->
        <shoudf :visible.sync="showshdfdialog" v-if="showshdfdialog" @choseObj="choseshoudf" oneflag
                :usercode="currentUser"
                title="选择售达方"/>
        <!--地址信息-->
        <areaSelect :visible.sync="showdizhiflag" v-if="showdizhiflag" @choseObj="choseDizhi" />
    </div>
</template>

<script>
    import ss from '../../api/SystemService'
    import big from 'big.js'
    import wxwl from '../../components/dialog/wxwl'
    import shoudf from '../../components/dialog/selectshdf'

    export default {
        components: {
            wxwl, shoudf
        },
        data() {
            var validatePhoneNumber = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入手机号码'));
                } else if (value !== '') {
                    if (/^0{0,1}(13[0-9]|15[0-9]|153|156|17[0-9]|18[0-9])[0-9]{8}$/.test(value)) {
                        callback();
                    } else {
                        callback(new Error('手机号码格式错误'));
                    }
                }
            };

            return {

                //选择用户类型开关
                checkUserType: true,
                //销售渠道，销售组织，分销渠道
                xsqyStr: '',
                xszzStr: '',
                fxqdStr: '',

                //地址，
                showdizhiflag: false,
                //售达方
                showshdfdialog: false,
                //物料
                showwuliaodialog: false,

                n: {
                    netPrice: '',
                    quota: '',
                    id: '',
                    paymentdate: '',
                },
                creditData: [],

                showdizhiflag: false,

                seeAddress: false,

                currentUser: null,

                objectList: {},

                showIsCustomed: false,
                showIsStockUp: false,
                showXiangmu: false,
                showIsFree: false,
                showHidden: true,
                showHidden2: false,
                objectName: '',
                //分销渠道
                options: [{
                    value: '00',
                    label: '通用分销渠道',
                }, {
                    value: 'X1',
                    label: '香港外销渠道'
                }, {
                    value: 'Z1',
                    label: '上海直销渠道',
                    children: [{
                        value: 'ZSH1',
                        label: '采购本部',
                    }, {
                        value: 'ZSH2',
                        label: '第三方采购',
                    }, {
                        value: 'ZSH3',
                        label: '第三方销售',
                    }],
                }],
                selectedOptions: ['00'],

                //sap订单参数
                orderCategory: '',


                // 限制收货时间不让选择今天以前的
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
                    }
                },

                //特价产品数量扣除信息
                TJ: [],
                cflag: false,
                //现金及信贷
                cashBalance: 0,
                cashOccupy: 0,
                creditBalance: 0,
                creditOccupy: 0,
                allTotalPrice: 0,
                freeTotal: 0,
                currency: '',
                expectTime: '',

                //新建订单对话框数据
                f: {},
                //查询属性
                labelPosition: 'left',
                q: {
                    orderCategory1: '',
                    projectName: '',
                    orderCategory: '',
                    saleGroupCode: '',
                    disChannelCode: '',
                    orderSubContract: '',
                    zCode: '',
                    id: '',
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                rules1: {
                    firsttelephone: [
                        {required: true, validator: validatePhoneNumber, trigger: 'blur'},
                    ]
                },
                c: {
                    firsttelephone: '',
                    soldToName: '',
                    soldToCode: '',
                    Ecode: '',
                    addressCode: '',
                    isStockUp: '',
                    soldToAreaCode: '',
                    customerChannelCode: '',
                    contactName: '',
                    receivedTime: '',
                    toAddress: '',

                },


                multipleSelection: [],
                //创建订单数据
                tableData: {
                    orderCategory1: '',
                    orderId: '',
                    orderStatus: 1,
                    orderProjectCode: '',
                    orderData: {
                        dcCode: '',
                        Ecode: '',
                        regionCode: '',
                        firsttelephone: '',
                        toProvincesCode: '',
                        toCityCode: '',
                        currencyCode: '',
                        orderCategory: '',
                        saleGroupCode: '',
                        disChannelCode: '',
                        zCode: '',
                        customerChannelCode: '',
                        contactName: '',
                        receivedTime: '',
                        toAddress: '',
                    },
                    orderProductList: [],
                },
                tableData2: [],
                params1: {
                    orderProductList: [],
                    saleGroupCode: '',
                    usercode: null,
                },
                //根据用户id查询出的所有项目
                allProjectByUser: [],
                clickActive: 1,

                showwuliaodialog: false,
                //收货地址相关
                options1: [],
                options2: [],
                options3: [],
                ruleForm: {
                    name: '',
                    phone: '',
                    province: '',
                    city: '',
                    region: '',
                    address: '',
                    provinceId: '',
                    cityId: '',
                    regionId: '',
                },
                //特价版本
                tjList: [],

            }
        },
        //页面加载前事件
        created() {
            this.checkUser();
            // this.getCredit();
            this.q = this.$route.query;
            //标准订单
            this.showIsStockUp = this.q.orderCategory1 == '2' ? true : false;
            //改制订单
            this.showIsCustomed = this.q.orderCategory1 == '3' ? true : false;
            //免费订单
            this.showIsFree = this.q.orderCategory1 == '6' ? true : false;
            
            this.selectedOptions = [this.q.disChannelCode];
            // 销售区域
            this.xsqyStr = this.$store.getters.dictname("xiaoshou_quyu", this.q.orderCategory);
            //内销
            if (this.q.orderCategory == '1') {
                this.xsqyStr = this.xsqyStr + "/" + this.$store.getters.dictname("xiaoshou_quyu_nx", this.q.orderCategory1);
                //外销
            } else if (this.q.orderCategory == '2') {
                this.xsqyStr = this.xsqyStr + "/" + this.$store.getters.dictname("xiaoshou_quyu_wx", this.q.orderCategory1);
            }
            //销售组织
            this.xszzStr = this.$store.getters.dictname("YLSalesOrganization_agent", this.q.saleGroupCode);

            // 分销渠道
            this.fxqdStr = this.$store.getters.dictname("fenxiao_qudao", this.q.disChannelCode);
            if (this.q.disChannelCode == 'Z1') {
                this.fxqdStr = this.fxqdStr + this.$store.getters.dictname("fenxiao_qudao_shanghai", this.q.zCode);
            }
            this.showUpXiangmu();
            this.showMeYourMoney();
            this.queryXiangmu();
        },

        methods: {

            //判断当前登陆人类型
            checkUser() {
                //经销商
                if (this._user.usertype == '1') {
                    this.c.soldToCode = this._user.usercode;
                    this.c.soldToName = this._user.username;
                    this.checkUserType = false;
                    this.currentUser = this._user.usercode;
                    this.c.soldToAreaCode = this._user.area;
                    this.queryMoney(this.c.soldToCode);
                } else {
                    this.c.soldToCode = null;
                    this.c.soldToName = null;
                }
            },

            //选择售达方
            openShoudf() {
                this.showshdfdialog = true;
            }
            ,
            choseshoudf(obj) {
                this.c.soldToName = obj.username;
                this.c.soldToCode = obj.usercode;
                if (this.showXiangmu == true && this.c.soldToCode != this.q.customerId) {
                    this.$msg.msge("项目对应经销商错误,请重新选择!")
                    return;
                }
                this.c.soldToAreaCode = obj.areaname;
                this.showshdfdialog = false
                this.queryMoney(this.c.soldToCode);
            },

            //区域选择
            choseDizhi(obj) {
                this.c.toAddress = obj.zhenobj.namepath + '/' + obj.addrdetail;

                this.c.toProvincesCode = obj.shengobj.name;
                this.c.toCityCode = obj.shiobj.name;

                this.c.addressCode = this.c.Ecode = obj.zhenobj.code;
                this.showdizhiflag = false;
            }
            ,

            handleIconClick() {
                this.showdizhiflag = true;
            }
            ,
            //添加产品信息
            showProcuct() {
                if (this.c.soldToName == null && this._user.usertype != '1') {
                    this.$msg.msge('请先选择售达方信息!')
                    return;
                }
                ;
                this.showwuliaodialog = true;
                this.currentUser = this.c.soldToCode == null ? this._user.usercode : this.c.soldToCode;
                this.objectList = {
                    tjdtid: '',
                    specialPriceNum: '',
                    id: '',
                    materialCode: '',
                    proModelCode: '',
                    proNumber: '',
                    proBenchmarkPrice: '',
                    specialPrice: '',
                    isStockUp: '',
                    spare3: '',
                    extraPrice: '',
                    finalPrice: '',
                    totalPrice: '',
                }
                this.objectList.id = this.$util.getUuid();
            },

            //特价产品数量扣除
            useTJ() {
                for (var i in this.tableData2) {
                    var del = {
                        id: i.tjdtid,
                        avaiNumber: new big(i.proNumber).minus(i.specialPriceNum).toString(),
                    }
                    this.TJ.push(del)
                }
                ss.OrderService.useTJ().then(rd => {
                    console.log('特价产品数量扣除', rd);
                });
            },

            choseWuliao(obj) {
                obj = obj[0];
                console.log('wuliao', obj);
                if (_.find(this.tableData2, {materialCode: obj.matecode})) {
                    this.$msg.msge("该物料已选择,请勿重复选择!")
                    return;
                }
                this.currency = obj.currency;
                this.objectList.materialCode = obj.matecode;
                this.objectList.proModelCode = obj.matedes;
                this.objectList.proBenchmarkPrice = obj.jizhj;
                this.objectList.specialPrice = obj.tjlist[0] == null ? '' : obj.tjlist[0].tejia;
                this.objectList.specialPriceNum = obj.tjlist[0] == null ? '' : obj.tjlist[0].sysl;
                this.objectList.tjdtid = obj.tjlist[0] == null ? '' : obj.tjlist[0].tjdtid;
                this.objectList.extraPrice = 100;
                this.tjList = obj.tjlist;

                //最终价
                this.objectList.finalPrice = obj.tjlist[0] == null ?
                    this.objectList.proBenchmarkPrice : this.objectList.specialPrice;

                this.objectList.proNumber = '0';
                this.objectList.totalPrice = '0';
                this.getAllTotalPrice();

                this.tableData2.push(this.objectList);
                this.showwuliaodialog = false;
                this.getCredit();
            },
            //特价选择
            choseTJ(x) {
                let item = _.find(this.tjList, {tejia: x.specialPrice});
                if (!item) {
                    return;
                }
                x.specialPriceNum = item.sysl;
                //最终价
                x.finalPrice = x.specialPrice == null ? x.proBenchmarkPrice : x.specialPrice;
                x.totalPrice = new big(x.proNumber).times(x.finalPrice).toString();

            },
            //清除特价事件
            clearEV(x) {
                x.specialPrice = null;
                x.specialPriceNum = '请选择特价';
                x.finalPrice = x.specialPrice == null ? x.proBenchmarkPrice : x.specialPrice;
                x.totalPrice = new big(x.proNumber).times(x.finalPrice).toString();
            },

            //查询余额
            queryMoney(x) {
                ss.OrderService.queryMoney(x).then(rd => {
                    this.cashBalance = rd.obj.cashBalance || '0';
                });
            },
            
            //查询免费订单余额
            queryFree(x) {
                ss.OrderService.queryMoney(x).then(rd => {
                    this.freeTotal = rd.freeTotal || '0';
                });
            },
            //免费订单余额扣除
            useFree(x){
                ss.OrderService.queryMoney(x).then(rd => {
                });
            },

            //查询用户所有信贷
            getCredit() {
                this.params1.saleGroupCode = this.q.saleGroupCode;
                this.params1.orderProductList = this.tableData2;
                this.params1.usercode = this.c.soldToCode;
                ss.OrderService.getCredit(this.params1).then(rd => {
                    this.creditData = rd;
                })
                console.log('sdfsdfdsfds')
                this.creditData.forEach((item, index) => {
                    this.creditData[index].creditMsg = '信贷总额' + item.quota + ',信贷账期' + item.paymentdate;
                    console.log('creditMsg', this.creditData[index].creditMsg);
                })
            }
            ,
            //信贷选择
            creditChange(n) {
                this.creditData.forEach((item, index) => {
                    if (item.id == n.id) {
                        this.n.quota = item.quota;
                        this.n.paymentdate = item.paymentdate;
                        this.n.creditMsg = item.creditMsg;
                    }
                })
            }
            ,
            //关联项目则显示项目
            showUpXiangmu() {
                if (this.q.projectName != '') {
                    this.showXiangmu = true;
                }
            }
            ,
            //删除该行项目产品信息
            deleteThis(x) {
                this.tableData2 = _.reject(this.tableData2, {'id': x});
            }
            ,

            closeIt() {
                this.seeAddress = true;
            }
            ,
            setAddress() {
                this.seeAddress = true;
            }
            ,

            //创建订单弹窗方法
            saveTo() {
                this.dialogFormVisible = false;
            }
            ,
            cancel() {
                this.dialogFormVisible = false;
                this.tableData2 = [];
                this.q = {};
                this.selectedOptions = [];
            }
            ,
            create() {
                this.dialogFormVisible = true;
                this.q = {};

            }
            ,
            //定制需求数据字典替换,定制为否时禁用选项
            queryCust(n) {
                n.forEach(function (val, index) {
                    val.cflag = val.spare3 == 0 ? true : false;

                    val.spare3 = val.spare3 === 0 ? '不可定制' : val.spare3;
                })
                this.tableData2 = n;
            }
            ,

            //分销渠道改变后方法
            handleChange(value) {
                if (value.length > 1) {
                    this.tableData.orderData.disChannelCode = value[0];
                    this.tableData.orderData.zCode = value[1];
                } else {
                    this.tableData.orderData.disChannelCode = value[0];
                }
            }
            ,

            //下单金额扣除
            showMeYourMoney() {
                this.cashOccupy = this.creditOccupy = 0;
                if (this.allTotalPrice <= this.cashBalance) {
                    //现金足够扣现金
                    this.cashOccupy = this.allTotalPrice;
                    //现金不足扣信贷
                } else if (this.allTotalPrice > this.cashBalance) {
                    //现金全部扣完
                    this.cashOccupy = this.cashBalance;
                    //剩余部分扣信贷
                    this.creditOccupy = this.allTotalPrice - this.cashBalance;
                }
            }
            ,

            //勾选事件
            handleSelectionChange(val) {
                this.multipleSelection = val;
                this.getAllTotalPrice(val);
            }
            ,
            //计算每行成交价
            getFinalPrice(x) {
                if (x == null) {
                    return;
                }
                x.forEach((item, index) => {
                    item.finalPrice = item.specialPrice == null ? item.proBenchmarkPrice : item.specialPrice;
                })
                this.tableData2 = x;
            },
            //计算每行总价
            getETotalPrice(x) {
                if (x == null) {
                    return;
                }
                x.forEach((item, index) => {
                    item.totalPrice = new big(item.proNumber).times(item.finalPrice).toString();
                })
                this.tableData2 = x;
                this.getAllTotalPrice(this.tableData2);
            }
            ,
            //数量改变-总价改变
            getTotalPrice(n) {
                var c = 0;
                if (n.specialPrice > 0) {
                    c = new big(n.specialPrice);
                } else {
                    c = n.finalPrice;
                }
                n.proNumber = n.proNumber == '' ? 0 : n.proNumber;
                n.totalP = new big(n.proNumber).times(c);
                n.totalPrice = (n.totalP).toString();
                n.finalPrice = c.toString();
                this.getAllTotalPrice(n);
            }
            ,

            //总价总和改变
            getAllTotalPrice() {
                this.allTotalPrice = 0;
                var aaa = 0;
                var bbb = 0;
                this.tableData2.forEach(function (val, index) {
                    aaa = new big(aaa).plus(val.totalPrice);
                })
                big.DP = 2;
                bbb = new big(aaa).div(1.3);
                this.allTotalPrice = aaa.toString();
                this.n.netPrice = bbb.toString();
                this.showMeYourMoney();
            }
            ,

            //获取该项目下所有产品行
            queryXiangmu() {
                if (this.q.id == '') {
                    return;
                }
                ss.OrderService.getFilteredProductPage(this.q).then(rd => {
                    this.q.total = rd.total;
                    this.page = rd
                    this.tableData2 = rd.records;
                    console.log(this.tableData2, "tabledata2")
                    this.q.orderSubContract = this.tableData2[0].orderSubContract;
                    this.getFinalPrice(this.tableData2);
                    this.getETotalPrice(this.tableData2);
                    //币种
                    var aaa = '';
                    this.tableData2.forEach(function (val, index) {
                        aaa = val.currencyCode;
                    })
                    this.currency = aaa;

                    this.queryCust(this.tableData2);
                    this.getCredit();
                })


                if (this.q.id == '') {
                    this.showHidden = true;
                    this.showHidden2 = false;
                } else {
                    this.showHidden = false;
                    this.showHidden2 = true;
                }

                this.getAllTotalPrice();
            }
            ,


            //自行添加一行产品信息
            getSingleOrder(x) {
                ss.OrderService.getSingleOrder(x).then(rd => {
                    x.proModelCode = rd.proModelCode;
                    x.proBenchmarkPrice = rd.proBenchmarkPrice;
                    x.finalPrice = rd.proBenchmarkPrice;
                    this.getTotalPrice(x);
                });
            }
            ,

            //获取当前用户所有项目详情
            projectManagePage() {
                ss.OrderService.projectManagePage().then(rd => {
                    this.allProjectByUser = rd;
                });
            },

            //创建新订单
            createNewOrder(p) {
                this.$msg.confirm("确认提交?", () => {
                    this.tableData.submitflag = p == '10' ? '暂存' : '提交';
                    var tableData111 = [];
                    this.tableData2.forEach(function (val, index) {
                        val.spare3 = val.spare3 == '否' ? 0 : 1;
                        tableData111.push(val);

                    })
                    this.tableData.orderProductList = tableData111;
                    if (this.tableData.orderProductList.length < 1) {
                        this.$msg.msge('订单提交失败,请先选择订单产品!');
                        return;
                    }
                    this.tableData.orderStatus = p;

                    this.tableData.orderData.areaId = this.c.addressCode;
                    this.tableData.creditId = this.n.id;

                    this.tableData.orderData.orderNetWorth = this.n.netPrice;

                    this.tableData.orderProjectCode = this.q.id;
                    this.tableData.orderData.currencyCode = this.currency;
                    this.tableData.orderData.orderCategory = this.q.orderCategory;
                    this.tableData.orderCategory1 = this.q.orderCategory1;
                    this.tableData.orderData.saleGroupCode = this.q.saleGroupCode;
                    this.tableData.orderData.disChannelCode = this.q.disChannelCode;
                    this.tableData.orderData.zCode = this.q.zCode;
                    this.tableData.orderData.customerChannelCode = this.c.customerChannelCode;
                    this.tableData.orderData.contactName = this.c.contactName;
                    this.tableData.orderData.receivedTime = this.c.receivedTime;
                    this.tableData.orderData.toAddress = this.c.toAddress;
                    this.tableData.orderData.isStockUp = this.c.isStockUp;
                    this.tableData.orderData.soldToCode = this.c.soldToCode;

                    this.tableData.orderData.toProvincesCode = this.c.toProvincesCode;
                    this.tableData.orderData.toCityCode = this.c.toCityCode;
                    this.tableData.orderData.firsttelephone = this.c.firsttelephone;

                    //免费订单
                    if(this.showIsFree && this.allTotalPrice > this.freeTotal){
                        this.$msg.msge('免费订单余额不足,请重新选择产品!');
                        return;
                        //非免费订单
                    }else if ((this.allTotalPrice > this.cashBalance) && this.n.id == '') {
                        this.$msg.msge('现金余额不足,请选择信贷!');
                        return;
                    }
                    ss.OrderService.createNewOrder(this.tableData).then(rd => {
                        this.$msg.msgs(rd.msg);
                        this.$router.push({path: "/dingd/myOrderList"});
                    });
                })

            }
            ,
            //跳转页面
            jump() {
                this.$msg.confirm("确认取消创建订单?", () => {
                    this.$router.push({path: "/dingd/myOrderList"})
                })
            }
            ,
            mounted() {
                //  this.queryXiangmu();
            }
            ,

            //收货地址相关
            choosepro() {
                this.ruleForm.cityId = '';
                this.ruleForm.regionId = '';
                this.ruleForm.city = ''
                this.ruleForm.region = '';
                let obj = {};
                obj = this.options1.find((item) => {
                    return item.shortname === this.ruleForm.province;
                });
                this.ruleForm.provinceId = obj.id;
                // console.log(this.ruleForm.province)
                this.ajax.post(this.$SYS.vsign + "/vst/goods/vsJfAddresses/selectList", {
                    level: 2,
                    pid: this.ruleForm.provinceId
                }).then((data) => {
                    // console.log(data,"获取市")
                    this.options2 = data;
                });
            }
            ,
            chooseCity() {
                this.ruleForm.regionId = '';
                this.ruleForm.region = '';
                // 获取名称
                let obj = {};
                obj = this.options2.find((item) => {
                    return item.shortname === this.ruleForm.city;
                });
                this.ruleForm.cityId = obj.id;
                // console.log(this.ruleForm.province)
                this.ajax.post(this.$SYS.vsign + "/vst/goods/vsJfAddresses/selectList", {
                    level: 3,
                    pid: this.ruleForm.cityId
                }).then((data) => {
                    // console.log(data,"获取区域")
                    this.options3 = data;
                });
            }
            ,
            chooseRegion() {
                // 获取名称
                let obj = {};
                obj = this.options3.find((item) => {
                    return item.shortname === this.ruleForm.region;
                });
                this.ruleForm.regionId = obj.id;
                // console.log(this.ruleForm.region)
            }
            ,
            addressConfirm() {
                this.c.toAddress = this.ruleForm.province + this.ruleForm.city + this.ruleForm.region + this.ruleForm.address;
                this.addressCancel();
            }
            ,
            addressCancel() {
                this.seeAddress = false;
                this.ruleForm = {};
            }
            ,
        }
        ,

    }

</script>


<style scoped>
    .queren {
        background-color: #006aca;
        color: white;
    }

    .anniu {
        margin-left: 6rem;
        margin-top: 30px;
    }

    .zancun {
        background-color: #24b5b8;
        color: white;
    }

    .quxiao, .zancun {

        width: 100px;
    }

    .make {
        width: 77px;
        padding-left: 17px;
    }

    .zhangqi {
        width: 80px;
        padding-left: 10px;
    }

    .yuan, .zhanyong, .xianjin, .money, .dingdan, .bizhong, .jiazhi, .renminbi {
        width: 82px;
        padding-left: 20px;
    }

    /* .renminbi {
        width: 80px;
        padding-left: 20px;
    } */

    .renminbi,
    .money,
    .yuan,
    .zhangqi,
    .make {
        background-color: white;
        font-size: 10px;
    }

    .bizhong,
    .dingdan,
    .xianjin,
    .zhanyong,
    .jiazhi {
        background-color: #ebf5ff;
        font-size: 15px;
        padding-left: 20px;
    }

    .bizhong,
    .renminbi,
    .dingdan,
    .money,
    .xianjin,
    .yuan,
    .zhangqi,
    .zhanyong,
    .jiazhi,
    .make {
        font-size: 15px;
        color: black;
        padding: 20px 0;
        padding-left: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .jieguo {
        border-bottom: 1px solid rgb(238, 236, 236);
        display: flex;
        margin-top: 12px;
    }

    span {
        color: white;
        position: relative;
        top: -12px;
        font-size: 14px;
    }

    img {
        width: 25px;
        padding: 5px 0;
        margin-left: 8rem;
    }

    .newProject {
        margin: 0 20px;
        background-color: rgb(94, 182, 233);
    }

    /* .h-crumbOut {
        margin-bottom: 20px;
    } */

    .h-piece {
        margin: 20px;
    }

    .h1 {
        margin-left: 27px;
    }

    .DshuR {
        width: 100%;
        height: 100%;
        border: none;
    }

    .bbbb {
        /* padding-top: 5px; */
        margin: 20px 20px 0 20px;
    }

    .message {
        padding: 20px 0;
        margin-bottom: 0;
        background-color: white;
    }

    .n-xiao .h-formbLine .h-elformWrap-2,
    .n-two .h-formbLine .h-elformWrap-2 {
        width: 33.333%;
    }

    .el-cascader {
        line-height: normal;
    }
</style>
<style>
    .n-two .h-formbLine .el-form-item__content .el-select,
    .n-two .el-form .h-formbLine .el-form-item__content .el-select {
        width: 0;
    }

    .n-xiao .h-formbLine .el-form-item__label,
    .n-two .h-formbLine .el-form-item__label {
        width: 43%;
    }

    .n-xiao .h-formbLine .el-form-item__content,
    .n-two .h-formbLine .el-form-item__content {
        width: 57%;
    }


    /* .el-table__header .el-table-column--selection .cell .el-checkbox::after {
        content: "全选";
        color: white;
        background-color: rgb(93, 172, 236);
        font-size: 10px;
    } */
</style>

<style scoped lang="scss">
    .areaSelect {
        position: fixed;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.6);
        top: 0;
        left: 0;
        z-index: 2019;

        .centerBlock {
            width: 700px;
            height: 400px;
            padding: 20px;
            border-radius: 20px;
            background-color: white;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }
</style>
<style>
    .aaa .el-dialog__headerbtn {
        display: none;
    }
</style>
